import ChangeRoleModal from "@/views/login/modals/change-role";
import RoleChangedModal from "@/views/login/modals/role-changed";
import {mapState} from "vuex";

export default {
  props: {},
  data() {
    return {
      showChangeRoleModal: false,
      showRoleChangedModal: false,
      showChangeRoleModalTitle: "",
      inactive: null,
      active: null,
      deleting: false
    }
  },
  components: {
    ChangeRoleModal,
    RoleChangedModal,
  },
  mounted() {},
  watch: {},
  computed: {
    ...mapState({
      deleting_status: state => state.Authenticate.deleting_status,
      options: state => state.Authenticate.options,
      logged: state => state.Chat.logged,
    })
  },
  methods: {
    closeChangeRoleModal() {
      this.showChangeRoleModal = false;
    },
    closeRoleChangedModal() {
      this.showRoleChangedModal = false;
    },
    onInactive(data) {
      const self = this;
      const {active, inactive} = data;
      self.showChangeRoleModalTitle = `
        You are attempting to switch permission levels from ${inactive.role.toUpperCase()} to ${active.role.toUpperCase()}.
        <br>
        All data from your previous account will be deleted and unable to be restored.  Do you wish to proceed?`;
      self.showChangeRoleModal = true;
      self.inactive = inactive;
      self.active = active;
    },
    confirmEraseAccount() {
      this.deleteInactiveAccount(this.inactive);
      this.confirmAccount(this.active);
    },
    deleteInactiveAccount(tenant) {
      const self = this;
      this.$store.dispatch("Authenticate/delete_old_account", {...tenant, owner_id: this.options.owner_id ? this.options.owner_id : this.logged.owner_id}).then(() => {
        self.deleting = true;
        self.closeChangeRoleModal();
      }).catch(error => {
        console.error(error);
        self.deleting = false;
      });
    }
  }
};
